import { colors } from "@indeed/ifl-tokens";
import { useState } from "react";
import { StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { Alert, Box, Button, ScrollView, TextArea, Text } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { useModalContext } from "../context/ApplicantInsightsModalContextProvider";

export const styles = StyleSheet.create({
  modalContent: {
    flexGrow: 0,
    paddingTop: 20,
    paddingBottom: 48,
    paddingLeft: 12,
    paddingRight: 12,
  },
  input: {
    height: 220,
  },
});

export function ApplicantInsightsFeedbackContent() {
  const { setApplicantInsightsPopoverProps, dismissApplicantInsightsPopover } = useModalContext();
  const gt = useI18n();
  const [feedback, setFeedback] = useState("");
  const { bottom } = useSafeAreaInsets();

  return (
    <ScrollView>
      <Box sx={[styles.modalContent, { paddingBottom: bottom }]}>
        <Text level={3} sx={{ color: colors.foreground["[base]"], marginBottom: 12 }}>
          {gt.gettext("Share your thoughts about applicant insights. (Optional)")}
        </Text>
        <TextArea
          value={feedback}
          onInput={setFeedback}
          counterLimit={500}
          textAreaHeight={styles.input.height}
        />

        <Alert
          status="info"
          sx={{ marginTop: 24 }}
          explainerText={gt.gettext(
            "Do not include any sensitive information such as phone numbers or email addresses.",
          )}
        />
        <Button
          variant="primary"
          onPress={() => {
            setApplicantInsightsPopoverProps((prev) => {
              return {
                ...prev,
                feedbackText: feedback,
                isOpen: false,
              };
            });
            dismissApplicantInsightsPopover();
          }}
          sx={{ marginTop: 24 }}
          disabled={feedback.length === 0}
        >
          <Text sx={{ color: colors.background["[base]"] }}>{gt.gettext("Submit feedback")}</Text>
        </Button>
      </Box>
    </ScrollView>
  );
}
